// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"14747":"da2761d7b46011183091","14900":"d7e073ce075431324dcc","16740":"f92d51ce379cfd86a333","19753":"333f733209577ff86494","20108":"947d8735b0e429918ddb","60868":"7a04ca4de1062c035900","65837":"be81108db8e935e09cdb"}[chunkId] + ".min.js";
};